import NumberField from '../../../../NumberField';
import { useColumnSelector } from './hooks';

type Props = {
  uuid: string;
};

export default ({ uuid }: Props) => {
  const count = useColumnSelector(uuid, "count");
  const sellPrice = useColumnSelector(uuid, "sellPrice");
  const totalPrice = count && sellPrice && count * sellPrice;

  return (
    <NumberField
      value={totalPrice ? totalPrice.toString() : "0"}
      suffix="TL"
      maxLength={10}
      disabled
    />
  );
};
